document.addEventListener("DOMContentLoaded", function () {
  var toggleFb = document.getElementById("toggleFb");
  var toggleVc = document.getElementById("toggleVc");
  var flexBuddySection = document.getElementById("flexBuddySection");
  var VideoCourseSection = document.getElementById("VideoCourseSection");

  // Set initial visibility and active button
  flexBuddySection.style.display = "block";
  VideoCourseSection.style.display = "none";
  toggleFb.classList.add("active");
  toggleVc.classList.remove("active");

  toggleFb.addEventListener("click", function () {
    // Show FlexBuddy and hide Video Course
    flexBuddySection.style.display = "block";
    VideoCourseSection.style.display = "none";
    toggleFb.classList.add("active");
    toggleVc.classList.remove("active");

    // Reset slider to first image for FlexBuddy
    var slickSlider = flexBuddySection.querySelector('.slideshow[data-main-carousel="true"]');
    if (slickSlider && $(slickSlider).hasClass('slick-initialized')) {
      $(slickSlider).slick('slickGoTo', 0);
    }
  });

  toggleVc.addEventListener("click", function () {
    // Hide FlexBuddy and show Video Course
    flexBuddySection.style.display = "none";
    VideoCourseSection.style.display = "block";
    toggleVc.classList.add("active");
    toggleFb.classList.remove("active");

    // Reset slider to first image and force refresh for Video Course
    requestAnimationFrame(function () {
      var slickSlider = VideoCourseSection.querySelector('.slideshow[data-main-carousel="true"]');
      if (slickSlider && $(slickSlider).hasClass('slick-initialized')) {
        $(slickSlider).slick('slickGoTo', 0); // Reset to first image
        $(slickSlider).slick('refresh'); // Force refresh for correct rendering
      }
    });
  });
});
